export default __webpack_public_path__ + "static/media/greentick_success.f861a17c.svg";